<template>
    <div>
        <message-component id="message" v-model="isMessage" :success="this.message.success" style="white-space:pre-wrap; word-wrap:break-word;">{{ message.text }}</message-component>
        <v-overlay :value="sending" z-index="10000">
            <v-progress-circular
                indeterminate
                size="64"
            ></v-progress-circular>
            <span class="loading">処理中です...</span>
        </v-overlay>

        <v-card class="mx-auto" width="1000" min-width="1000" color="#F4FEFB">
            <v-card-text>
                <pdf-upload-component @triggerEvent="changeFile" @triggerEvent2="deleteDbFile" :navi="navi" :db-file-list="items" :template="true" :multipleSend="true"></pdf-upload-component>
            </v-card-text>
        </v-card>
        <div class="text-center pt-2">
            <v-btn color="red" class="white--text" :disabled="isNotFileUpload" @click="next">次へ</v-btn>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            navi : [],
        },
        data() {
            return {
                uid: '',
                files: [],
                items: [],
                objectIds: [],
                message: {
                    success: false,
                    text: '',
                },
                sending: false,
            };
        },
        computed: {
            isMessage: {
                get() {
                    return this.message.text != '';
                },
                set(value) {
                    if (!value) {
                        this.message.text = '';
                    }
                }
            },
            isNotFileUpload: {
                get() {
                    if (this.files.length > 0 || this.items.length > 0) {
                        return false;
                    } else {
                        return true;
                    }
                },
                set(value) {
                    
                }
            }
        },
        methods: {
            next: async function() {
                this.sending = true;
                try {
                    let result = await this.save();
                    if (result && this.uid != null && this.uid.length) {
                        window.location = this.uid + "/info";
                    } else {
                        self.message.text = "保存処理に失敗しました";
                    }
                }
                finally {
                    this.sending = false;
                }
            },
            // 保存
            save: async function() {
                let formData = new FormData();
                for(let i = 0; i < this.files.length; i++){
                    formData.append('files[]', this.files[i][0].file);
                }
                //JSON文字列に変換
                formData.append('contractItems', JSON.stringify(this.items));
                let config = {
                    headers: {
                        'content-type': 'multipart/form-data'
                    }
                };
                let result = false;
                var self = this;
                await window.axios
                    .post('select', formData, config)
                    .then(function (response) {
                        if (response.data.success) {
                            result = true;
                            self.uid = response.data.uid;
                        } 
                        else {
                            result = false;
                            if (response.data.message) {
                                self.message.text = response.data.message;
                            } else {
                                self.message.text = "保存処理に失敗しました";
                            }
                            self.message.success = false;
                        }
                    })
                    .catch(function (response) {
                        result = false;
                        console.log(response);
                        self.message.text = "保存処理に失敗しました";
                        self.message.success = false;
                    }
                );
                return result;
            },
            
            changeFile: function(value) {
                // console.log(value);
                this.files = value;
                // this.next();
            },
            
            deleteDbFile: function(index) {
                this.$delete(this.items, index);
            },
        },
    };
</script>
